// extracted by mini-css-extract-plugin
module.exports = {"container":"layoutWithLogo_container__6Baxe","logoWrapper":"layoutWithLogo_logoWrapper__nYYPJ","logo":"layoutWithLogo_logo__XTaOJ","content":"layoutWithLogo_content__2hNbj"};